import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";

function DescriptionOrderSadan(props) {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  return (<>
    <div className="div__group__input_select mx-2">
      <label className="form-check-label" htmlFor={"rnd1"}>
        توضیحات
      </label>
      <textarea
        className="form-control newinput"
        value={data.description}
        onChange={e=>{
          setData({description:e.target.value})
        }}

      >
      </textarea>
    </div>
  </>);
}

export default DescriptionOrderSadan;